<template lang="pug">
    span.component-status.statuslight(v-if="status", :class="'status-'+status")

</template>
<script type="text/babel">
    export default{
        name: "Status",
        components: {},
        data(){
            return {}
        },
        created() {
        },
        methods: {},
        computed: {},
        props: ['status']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// Status.vue?dd844c2e